import { ReactNode } from 'react';
import classNames from 'classnames';
import BootstrapCard from 'react-bootstrap/Card';

import './Card.scss';

type CardProps = {
  className?: string;
  headerClass?: string;
  header?: ReactNode;
  bodyClass?: string;
  children?: ReactNode;
};

/**
 * This function wraps content in a small box that visually separates it from surrounding content. It is a thin
 * wrapper around the Bootstrap component so that we can style it.
 *
 * @prop className      custom class for the card
 * @prop headerClass    custom class for the card header
 * @prop header         component to use as the card header
 * @prop bodyClass      custom class for the card body
 * @prop children       component that makes up the card's content
 */
function Card({ className, headerClass, header, bodyClass, children }: CardProps): JSX.Element {
  const cardClass = classNames('Card', className);
  const cardHeaderClass = classNames('Card__Header', headerClass);
  const cardBodyClass = classNames('Card__Body', bodyClass);

  const cardHeader = header && <BootstrapCard.Header className={cardHeaderClass}>{header}</BootstrapCard.Header>;

  return (
    <BootstrapCard className={cardClass}>
      {cardHeader}
      <BootstrapCard.Body className={cardBodyClass}>{children}</BootstrapCard.Body>
    </BootstrapCard>
  );
}

export default Card;
